<template>
    <div class="survey-form-create">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'surveyDetails' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Create Survey Form
                        </div>
                    </div>
                </div>
            </div>

            <hr />
        </div>
        <form @submit.prevent="checkForm" action="#" method="post">

            <div class="container">
                <h3 class="section-title mt-5">Survey Detail</h3>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group" :class="{ 'form-is-error': $v.survey.name.$error }">
                            <label for="">Survey name *</label>
                            <input class="form-control" v-model.trim="$v.survey.name.$model" type="text">
                            <div class="invalid-feedback form-error-msg" v-if="!$v.survey.name.required">Team name is
                                required</div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group" :class="{ 'form-is-error': $v.survey.program_id.$error }">
                            <label for="">Programme *</label>

                            <select class="custom-select form-control" v-model.trim="$v.survey.program_id.$model"
                                name="program" id="program">
                                <option value="">- Select programme -</option>
                                <option v-for="program in programsData" v-bind:key="program.id" :value="program.id">
                                    {{program.name}}</option>
                            </select>

                            <div class="invalid-feedback form-error-msg" v-if="!$v.survey.program_id.required">Programme
                                is
                                required</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group" :class="{ 'form-is-error': $v.survey.valid.$error }">
                            <label for="">Status *</label>
                            <div>
                                <div class="custom-control-inline pill-radio">
                                    <input v-model.trim="$v.survey.valid.$model" id="valid" type="radio" name="valid"
                                        value="1" class="custom-control-input">
                                    <label class="" for="valid">Valid</label>
                                </div>

                                <div class="custom-control-inline pill-radio">
                                    <input v-model.trim="$v.survey.valid.$model" id="invalid" type="radio" name="valid"
                                        value="0" class="custom-control-input">
                                    <label class="" for="invalid">Invalid</label>
                                </div>
                            </div>

                            <div class="invalid-feedback form-error-msg" v-if="!$v.survey.valid.required">valid is
                                required</div>
                        </div>
                    </div>
                </div>

                <div class="card mb-4" v-for="(section,index) in survey.field_params" v-bind:key="section.id">
                    <h5 class="card-header">
                        <label for="">Section name *</label>
                        <input class="form-control" v-model="section.name" type="text" required>
                        <button @click="removeSection(index)" v-if="index!=0" type="button" class="close"
                            aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </h5>


                    <div class="card-body" v-for="(card, index) in section.cards" v-bind:key="card.id">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Question name * </label>
                                    <input class="form-control" v-model="card.title" type="text" required>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Type *</label>
                                    <select @change="initialCard(card)" class="custom-select form-control"
                                        v-model="card.type" name="type" id="type" required>
                                        <option value="text">Short answer</option>
                                        <option value="textarea">Paragraph</option>
                                        <option value="radio">Multiple choice</option>
                                        <option value="checkbox">Checkboxes</option>
                                        <option value="select">Drop-down</option>
                                        <option value="date">Date</option>
                                        <option value="time">Time</option>
                                        <option value="image">Image</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="">Option</label>
                                    <div style="position: relative;" v-for="(answer, index) in card.answers" v-bind:key="answer.id" class="mb-3"
                                        v-bind:index="index">
                                        <input class="form-control input-survey-option" type="text" :disabled="!checkType(card)"
                                            v-model="answer.name">
                                        <button v-if="checkType(card)" type="button" class="close close-survey-option" aria-label="Close" @click="removeAnswer(card, index)">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="btn btn-ecdc btn-shadow mt-3" v-if="checkType(card)" @click="addAnswer(card)">Add Option</div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="form-group d-flex justify-content-between align-items-center mb-0">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" v-model="card.setting.required"
                                            :id="'required'+card.id">
                                        <label class="custom-control-label" :for="'required'+card.id">Required</label>
                                    </div>
                                    <button class="btn btn-danger btn-shadow" @click="removeQuestion(section, index)">Delete</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <button class="btn btn-ecdc btn-shadow mr-3">Create</button>
                <button type="button" class="btn btn-ecdc btn-shadow mr-3" @click="previewForm()">Preview</button>
                <button type="button" class="btn btn-link"
                    @click="$router.push({ name: 'surveyDetails' , params:{survey} });">Cancel</button>
            </div>
        </form>

        <div id="float-menu">
            <div class="card">
                <div class="card-body">
                    <div class="form-group">
                        <label for="">Current section</label>
                        <select class="custom-select form-control" name="selectedSection" id="selectedSection"
                            v-model="selectedSection">
                            <option v-for="section in survey.field_params" v-bind:key="section.id" :value="section">
                                {{section.name}}</option>
                        </select>
                    </div>
                    <div @click="addSection()" class="btn btn-ecdc btn-shadow btn-block mb-3">Add section</div>

                    <div @click="addCard()" class="btn btn-ecdc btn-shadow btn-block">Add question</div>
                </div>
            </div>
        </div>

        <app-loader v-show="isLoading"></app-loader>

    </div>
</template>



<script>
import { checkPermission, getPrograms, storeSurvey } from '../api'
import { getProj } from '../helpers'
import Loader from './Loader.vue'
import { required } from 'vuelidate/lib/validators'

export default {
    components: {
        appLoader: Loader
    },
    data() {
        return {
            survey:{
                name:"Survey",
                program_id:"",
                project_id:"",
                valid:0,
                field_params:[{
                    id:Date.now(),
                    name: "Section 1",
                    cards:[{
                    id:Date.now(),
                    title: "",
                    type:"text",
                    value:[],
                    profile_image:"",
                    profile_image_preview:"",
                    answers:[{
                        id:Date.now(),
                        name:"Option 1"
                    }],
                    setting:{
                        required:false
                    }
                    }]
                }]
            },
            selectedSection: [],
            programsData: "",
            defaultProject: getProj()['projId'],
            isLoading: false
        }
    },
    validations: {
        survey: {
            program_id: {
                required
            },
            name: {
                required
            },
            valid:{
                required
            }
        }
    },
    async mounted() {
        this.selectedSection = this.survey.field_params[0];
        await this.getPrograms();
    },
    methods: {
        async checkPermission(permission) {
            try {
                const result = await checkPermission({permission:permission})
                return result.data.data;
            }
            catch(err) {

                alert(err);
            }
        },
        async getPrograms() {

            try {
                const result = await getPrograms(this.defaultProject)
                this.programsData = result.data.data;
            }
            catch(err) {

                alert(err.response.data.message);
            }
        },
        async checkForm() {
            
            const _this = this;

            this.$v.survey.$touch();

            if(this.$v.survey.$invalid) {

                this.isError = true;
                window.scrollTo(0, 0);

                setTimeout(function() { 
                    
                    _this.isError = false;
                }, 2000);
            }
            else {

                this.isLoading = true;

                try {
                    this.survey.project_id = this.defaultProject;
                    await storeSurvey(this.survey);

                    this.isSuccess = true;
                    window.scrollTo(0, 0);

                    setTimeout(function() { 
                        
                        _this.isSuccess = false;
                        _this.$router.push({ name: "surveyDetails" });
                    }, 2000);
                }
                catch(err) {
                    alert(err.response.data.message);
                }

                this.isLoading = false;
            }
        },
        addAnswer(card) {
            var tmp = {
                id:Date.now(),
                name:"Option "+ (card.answers.length + 1)
            };
            card.answers.push(tmp);
        },
        removeQuestion(section, index) {
            if (section.cards.length>1) {
                section.cards.splice(index, 1);
            }
        },
        removeSection(index) {
            if (this.survey.field_params.length>1) {
                this.survey.field_params.splice(index, 1);
            }
        },
        removeAnswer(card, index) {
            if (card.answers.length>1) {
                card.answers.splice(index, 1);
            }
        },
        checkType(card){
            switch (card.type) {
                case "radio":
                case "checkbox":
                case "select":
                    return true;
                default:
                    card.answers[0].name = card.type;
                    return false;
            }
        },
        previewForm() {
            var tmp_survey = this.survey;

            let routeData = this.$router.resolve({
            name: 'surveyFormPreview',
            query: {
                params: JSON.stringify(tmp_survey)
            }
            });
            window.open(routeData.href, '_blank');
        },
        initialCard(card){
            // card.title = "";
            // card.type = card.type;
            card.answers = [{
                    id:Date.now(),
                    name:"Option 1"
                }];
        },
        addCard(){
            var tmp = {
                id: Date.now(),
                title: "",
                type:"text",
                value:[],
                profile_image:"",
                profile_image_preview:"",
                answers:[{
                    id:Date.now(),
                    name:"Option 1"
                }],
                setting:{
                    required:false
                }
            };
            this.selectedSection.cards.push(tmp);
        },
        addSection(){
            var tmp = {
                    id:Date.now(),
                    name: "Section "+ (this.survey.field_params.length + 1),
                    cards:[{
                    id:Date.now(),
                    title: "",
                    type:"text",
                    value:[],
                    profile_image:"",
                    profile_image_preview:"",
                    answers:[{
                        id:Date.now(),
                        name:"Option 1"
                    }],
                    setting:{
                        required:false
                    }
                    }]
                
            };
            this.survey.field_params.push(tmp);
            this.selectedSection = this.survey.field_params[this.survey.field_params.length-1];

        }
    }
}
</script>